import { FormHero, HeroTitle, Container } from './styles'

const Hero = () => (
  <FormHero>
    <Container>
      <HeroTitle>
        As melhores vagas para tecnologia, design e artes visuais.
      </HeroTitle>
    </Container>
  </FormHero>
)

export default Hero
